import { ActivatedRouteSnapshot, ViewTransitionInfo } from '@angular/router';

/**
 * Skips the page transition when motion is reduced, when only the query changes (a dialog writing
 * `?previewAsset=` would otherwise animate the page under it) and while a dialog is open, because a
 * body-level dialog would flash behind the sheet snapshot.
 */
export function skipUnwantedViewTransition({ transition, from, to }: ViewTransitionInfo): void {
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  const samePath = primaryPathOf(from) === primaryPathOf(to);
  const dialogOpen = document.querySelector('.p-dialog-mask, .p-overlay-mask') !== null;
  if (reducedMotion || samePath || dialogOpen) {
    transition.skipTransition();
  }
}

export function primaryPathOf(snapshot: ActivatedRouteSnapshot | null): string {
  const segments: string[] = [];
  for (let route = snapshot; route; route = route.firstChild) {
    segments.push(...route.url.map((segment) => segment.path));
  }
  return segments.join('/');
}
